import { render, staticRenderFns } from "./editanggaran.vue?vue&type=template&id=f76abbe6&"
import script from "./editanggaran.vue?vue&type=script&lang=js&"
export * from "./editanggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports